import { useTranslation } from 'react-i18next';

import { Spend } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { formatCompactNumber } from 'services/numberFormat';

import { quotaI18nKeys } from '../i18n';

import { StyledQuotaBadge } from './styles';
import type { BadgeType, Variant } from './types';

type Props = {
  type: BadgeType;
  value: number;
  variant?: Variant;
};

export const QuotaBadge = ({ type, value, variant = 'info' }: Props) => {
  const { t } = useTranslation();

  const getContent = (): string => {
    const formattedValue = formatCompactNumber(value);

    switch (type) {
      case 'total':
        return t(quotaI18nKeys.total, { value: formattedValue });
      case 'count':
      default:
        return formattedValue;
    }
  };

  return (
    <StyledQuotaBadge $variant={variant}>
      <Spend size={16} color={colorsPalettes.midnight[400]} />

      <span>{getContent()}</span>
    </StyledQuotaBadge>
  );
};
